import { render, staticRenderFns } from "./architecture.vue?vue&type=template&id=4e51d471&scoped=true&"
import script from "./architecture.vue?vue&type=script&lang=js&"
export * from "./architecture.vue?vue&type=script&lang=js&"
import style0 from "./architecture.vue?vue&type=style&index=0&id=4e51d471&prod&lang=scss&"
import style1 from "./architecture.vue?vue&type=style&index=1&id=4e51d471&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e51d471",
  null
  
)

export default component.exports